import { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type ScrollTopProps = PropsWithChildren<Record<string, never>>;

function ScrollTop({ children }: ScrollTopProps) {
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return <>{children}</>;
}

export { ScrollTop };
